// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3N360","colMin":"styles_colMin__1WqHb","colCheckbox":"styles_colCheckbox__20aLE"};